import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(rootElement);

/**
 * Two boot paths, chosen before anything heavy is imported.
 *
 * `/embedded/*` is the marketing site framing us for the personalized template
 * preview. It needs Supabase, the API client and the renderer — and none of the
 * product shell. Both roots are dynamic imports so webpack actually splits
 * them; a static import of either would put it back in the main bundle and
 * undo the whole point.
 */
const rootModule = window.location.pathname.startsWith('/embedded/')
  ? import('./embeddedRoot')
  : import('./appRoot');

void rootModule.then(({ default: Root }) => {
  root.render(
    <React.StrictMode>
      <Root />
    </React.StrictMode>
  );
});
